import { createFileRoute } from "@tanstack/react-router";
import { ServiceLayout } from "@/components/ServiceLayout";
import { img } from "@/lib/images";
import { canonicalLinks, routeMeta } from "@/lib/seo";

export const Route = createFileRoute("/services/auditing")({
  head: () => ({
    meta: [
      ...routeMeta("/services/auditing"),
      { title: "Financial Audit Services in Winter Garden | CCOB" },
      { name: "description", content: "Financial statement audits, internal audits, compliance reviews, and business financial assessments from a licensed CPA in Winter Garden, FL." },
      { property: "og:title", content: "Financial Audit Services — CCOB And Company PA" },
      { property: "og:description", content: "Financial statement audits, internal audits, compliance reviews, and business financial assessments." },
    ],
    links: canonicalLinks("/services/auditing"),
  }),
  component: () => (
    <ServiceLayout
      eyebrow="Financial Audits"
      title="Financial Audit Services"
      subtitle="Independent financial audits, internal reviews, and business financial assessments — focused strictly on financial reporting integrity."
      hero={img.heroAuditing}
      image={img.auditing}
      intro="Our Financial Audit practice is dedicated to evaluating the accuracy, integrity, and reliability of your financial information. We deliver objective assurance, internal review, and reporting audits that protect your business and inform smart decisions."
      items={[
        { title: "Financial Statement Audits", desc: "Independent audits of your financial statements with clear findings and recommendations stakeholders can rely on." },
        { title: "Internal Audits", desc: "Objective reviews of internal controls, processes, and risk areas to strengthen operations from the inside out." },
        { title: "Compliance Reviews", desc: "Stay aligned with industry regulations, reporting standards, and contractual obligations." },
        { title: "Accounting & Reporting Audits", desc: "Targeted audits of accounting records and financial reporting to ensure accuracy and consistency." },
        { title: "Business Financial Assessments", desc: "Comprehensive assessments of your overall financial health, performance, and reporting practices." },
      ]}
    />
  ),
});
